import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderAdditionalCostLineItemDepartmentsAdapter = getAdapter({ idFieldName: 'value' });

const orderAdditionalCostLineItemDepartmentsSlice = createSlice({
    name: 'orderAdditionalCostLineItemDepartments',
    initialState: orderAdditionalCostLineItemDepartmentsAdapter.getInitialState(),
    reducers: {
        setOrderAdditionalCostLineItemDepartments: (state, { payload: { orderAdditionalCostLineItemDepartments } }) => {
            orderAdditionalCostLineItemDepartmentsAdapter.setAll(state, orderAdditionalCostLineItemDepartments);
        },
    },
});

const selectors = orderAdditionalCostLineItemDepartmentsAdapter.getSelectors(({ orderAdditionalCostLineItemDepartments }) => orderAdditionalCostLineItemDepartments);

export const getOrderAdditionalCostLineItemDepartments = (state) => selectors.selectAll(state);

export const {
    setOrderAdditionalCostLineItemDepartments,
} = orderAdditionalCostLineItemDepartmentsSlice.actions;

export default orderAdditionalCostLineItemDepartmentsSlice.reducer;
